// API Configuration


export const API_CONFIG = {
  // Base URLs for different environments
  BASE_URL: {
  development: 'http://localhost:8081/api',
  staging: '/api',
  production: '/api'
},

  // API Endpoints
  ENDPOINTS: {
    // Auth endpoints
    AUTH: {
      LOGIN: '/auth/login',
      LOGOUT: '/auth/logout',
      REGISTER: '/auth/signup',
      FORGOT_PASSWORD: '/auth/forgot-password',
      RESET_PASSWORD: '/auth/reset-password',
      VERIFY_EMAIL: '/auth/verify-email',
      REFRESH_TOKEN: '/auth/refresh-token',
      CHECK_EMAIL: '/auth/check-email', // New endpoint for checking email existence
    },

    // User endpoints
    USER: {
      PROFILE: '/user/profile',
      UPDATE_PROFILE: '/user/profile/update',
      CHANGE_PASSWORD: '/user/password/change',
    },

    // Transaction endpoints
    TRANSACTIONS: {
      LIST: '/transactions',
      CREATE: '/transactions',
      UPDATE: '/transactions/:id',
      DELETE: '/transactions/:id',
    },

    // Account endpoints
    ACCOUNTS: {
      LIST: '/accounts',
      CREATE: '/accounts',
      UPDATE: '/accounts/:id',
      DELETE: '/accounts/:id',
    },

    // Reports endpoints
    REPORTS: {
      GENERATE: '/reports/generate',
      DOWNLOAD: '/reports/download/:id',
    },
  },

  // Request timeout in milliseconds
  TIMEOUT: 30000,

  // Default headers
  HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  }
};

// Get current environment
export const getCurrentEnvironment = (): 'development' | 'staging' | 'production' => {
  if (import.meta.env.MODE === 'production') {
    return 'production';
  }
  if (import.meta.env.MODE === 'staging') {
    return 'staging';
  }
  return 'development';
};

// Get base URL for current environment
export const getBaseUrl = (): string => {
  const env = getCurrentEnvironment();
  return API_CONFIG.BASE_URL[env];
};

